// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MenuItemDropdown_wrap__ysjry"};